// Thin sessionStorage wrapper for the admin JWT.
// Isolated in its own module to break the api.js ↔ auth.js circular import.
// No other file should read sessionStorage directly — always go through these helpers.
const TOKEN_KEY = 'pg_admin_token';
const EMAIL_KEY = 'pg_admin_email';

const store = () => (typeof window !== 'undefined' ? window.sessionStorage : null);

export const getToken = () => {
  const s = store();
  return s ? s.getItem(TOKEN_KEY) : null;
};

export const setSession = (token, email) => {
  const s = store();
  if (!s) return;
  s.setItem(TOKEN_KEY, token);
  s.setItem(EMAIL_KEY, email);
};

export const clearSession = () => {
  const s = store();
  if (!s) return;
  s.removeItem(TOKEN_KEY);
  s.removeItem(EMAIL_KEY);
};

export const getAdminEmail = () => {
  const s = store();
  return s ? s.getItem(EMAIL_KEY) || '' : '';
};
